import type { Response } from "./_type";

import { useGet } from "~/common/hooks";

/** useChatSessionsList */
export const useGetConversationList = (
  external_user: string,
  enabled: boolean
) => {
  /** URL */
  const url = `/users/${external_user}/chat-sessions/`;

  /** return */
  return useGet<Response>(url, undefined, { enabled });
};
